/* eslint-disable no-case-declarations */
import React, { useContext, useEffect, useState } from "react"

import InfiniteScroll from "../../../../atoms/InfiniteScroll"
import Input from "../../../../atoms/Input"
import styles from "./index.module.scss"
import RcmpLoading from "../../../../atoms/Loading"
import intl from "react-intl-universal"
import { fnFormatDateFromUTC, fnFormatedNumber } from "../../../../../utils/date"
import AuthContext from "../../../../../contexts/Auth"
import TextTruncate from "../../../../atoms/TextTruncate"

const A_RUN_FIELDS_HISTORY = [
  'analyte_run_status_change', 'eqpanltrun_cconclusion', 'eqpanltrun_cimmediate_action', 'eqpanltrun_drelease', 'run-causes'
]

export const HistoryComponent = ({
  history,
  infoInfinitScroll,
  setPerPage,
  isLoadHistory,
  setSearchType,
  setSearchText,
  searchHistory,
}) => {
  const { oUser } = useContext(AuthContext)

  const [dataHistory, setDataHistory] = useState([])

  function debounce(func, delay) {
    let timerId

    return function (...args) {
      clearTimeout(timerId)

      timerId = setTimeout(() => {
        func.apply(this, args)
      }, delay)
    }
  }

  function fnNextPage(page) {
    setPerPage(page)
  }

  const fnManiputeHistoryType = (cAction, oHistory) => {
    const epicInnerCIQ = oHistory.history_cfield
    const oldValue = oHistory?.history_cold_value

    switch (cAction) {
      case "created":
        if (searchHistory === "analyte") {
          return intl.get("ciq.history.create_analyte")
        }
        if (searchHistory === "analyte-control") {
          return intl.get("ciq.history.added_analyte")
        }
        if (searchHistory === "analyte-equipment") {
          return intl.get("ciq.history.added_analyte")
        } else if (searchHistory.includes("equipment")) {
          return intl.get("ciq.history.create_equipment")
        } else if (Object.keys(oHistory).includes("history_cfield")) {
          return intl.get("ciq.history.create_control")
        } else {
          return intl.get("ciq.history.create_control")
        }

      case "update":
        if (
          searchHistory === "analyte" ||
          searchHistory === "analyte-control" ||
          searchHistory === "analyte-equipment"
        ) {
          return intl.get("ciq.history.update_analyte")
        } else if (
          epicInnerCIQ === "equipment" ||
          epicInnerCIQ.includes("equipment_analyte") ||
          epicInnerCIQ?.includes("eqpanlt_bstatus") ||
          epicInnerCIQ?.includes("equipment") ||
          epicInnerCIQ?.includes("x") ||
          epicInnerCIQ?.includes(":1") ||
          epicInnerCIQ?.includes(":3") ||
          epicInnerCIQ?.includes(":2") ||
          epicInnerCIQ?.includes(":1")
        ) {
          return intl.get("ciq.history.update_equipment")
        } else if (A_RUN_FIELDS_HISTORY.includes(epicInnerCIQ)) {
          if (epicInnerCIQ === "analyte_run_status_change") {
            const nRunStatusId = JSON.parse(oHistory?.history_cnew_value)?.status_nid || 1

            const runsStausHashmap = {
              1: "ciq.history.analyte_run_change",
              2: "ciq.history.analyte_run_status_disapproved",
              3: "ciq.history.analyte_run_status_approved",
            }

            return intl.get(runsStausHashmap[nRunStatusId])
          }

          return intl.get("ciq.history.analyte_run_change")
        } else {
          return intl.get("ciq.history.update_control")
        }
      case "launched":
        return intl.get("ciq.history.launch_register")
      case "deleted":
        if (epicInnerCIQ === "run") {
          return intl.get("ciq.history.deleted.deleted_run_action")
        }

        return intl.get("ciq.history.deleted.deleted_register")
      case "sigma":
        if (epicInnerCIQ === "drm") {
          const bHasDeletedDrm = JSON.parse(oHistory?.history_cnew_value)?.eqpanltdrm_nvalue == null
          if (bHasDeletedDrm) {
            return intl.get("ciq.history.sigma.delete_drm")
          }
          return intl.get("ciq.history.sigma.add_drm")
        }

        if (epicInnerCIQ === "biovar_nid") {
          return intl.get("ciq.history.sigma.biological_variation_change")
        }

        if (epicInnerCIQ === "avarage_drm") {
          return intl.get("ciq.history.sigma.average_change")
        }

        if (epicInnerCIQ === "sigma" || epicInnerCIQ === "bsigma") {
          return intl.get("ciq.history.sigma.sigma_change")
        }
        break
      case "":
        return intl.get("ciq.history.launch_register")
    }
  }

  const fnManiputeHistoryAction = (cAction, oHistory) => {
    const epicInnerCIQ = oHistory.history_cfield

    const oldValue = oHistory?.history_cold_value
    const newValue = oHistory?.history_cnew_value

    // console.log({epicInnerCIQ, oldValue, newValue})

    const cUserTimeZone = oUser?.data?.user_ctimezone

    const transformDate = (date) => {
      const [data] = fnFormatDateFromUTC(
        `${date} 12:00`,
        "DD/MM/YYYY - HH:mm",
        cUserTimeZone,
      ).split(" - ")

      return data
    }

    switch (cAction) {
      case "created":
        if (searchHistory === "analyte") {
          return intl.get("ciq.history.created_analyte")
        }
        if (searchHistory === "analyte-control") {
          return intl.get("ciq.history.linked_analyte_control")
        }
        if (searchHistory === "analyte-equipment") {
          return intl.get("ciq.history.linked_analyte_equipment")
        } else if (searchHistory.includes("equipment")) {
          return intl.get("ciq.history.created_equipment")
        } else {
          return intl.get("ciq.history.created_control")
        }
      case "update":
        // RUNS FIELDS CHANGE
        if (A_RUN_FIELDS_HISTORY.includes(epicInnerCIQ)) {
          let values;
          try {
            values = JSON.parse(newValue)
          } catch(e) {
            values = newValue
          }
          const nRunNumber = values?.run_number
          const cAnalyteName = values?.anlt_cname
          const value = values?.value

          const aRunsHashfields = {
            "eqpanltrun_cimmediate_action": intl.get("ciq.immidiate_action"),
            "eqpanltrun_cconclusion": intl.get("ciq.conclusion"),
          }

          if (Object.keys(aRunsHashfields).includes(epicInnerCIQ)) {
            if (!oldValue) {
              return intl.get("ciq.history.updated.runs.add_to_field", {
                value: value || newValue,
                field: aRunsHashfields[epicInnerCIQ],
                run: nRunNumber,
                analyte: cAnalyteName
              })
            }

            return intl.get("ciq.history.updated.runs.update_to_field", {
              value: value || newValue,
              oldValue: oldValue,
              field: aRunsHashfields[epicInnerCIQ],
              run: nRunNumber,
              analyte: cAnalyteName
            })
          }

          if (epicInnerCIQ === "run-causes") {
            const cCauses = values?.causes?.length > 0 ? values?.causes.map(c => c?.cause_cdescription)?.join(", ") : values?.causes?.cause_cdescription
            if (!oldValue) {
              return intl.get("ciq.history.updated.runs.add_causes", {
                causes: cCauses,
                run: nRunNumber,
                analyte: cAnalyteName
              })
            }
            
            let oldValues;
            try {
              oldValues = JSON.parse(oldValue)
            } catch(e) { 
              oldValues = oldValue
            }
            
            const cOldCause = Array.isArray(oldValues) ? oldValues?.map(c => c?.cause_cdescription)?.join(", ") : oldValues?.cause_cdescription
            return intl.get("ciq.history.updated.runs.update_causes", {
              causes: cCauses,
              oldCauses: cOldCause,
              run: nRunNumber,
              analyte: cAnalyteName
            })
          }
        }

        // ANALYTE
        if (epicInnerCIQ === "anlt_result_options" && oldValue === null) {
          return intl.get("ciq.history.updated.inserted_field", {
            field: newValue,
          })
        }
        if (epicInnerCIQ === "anlt_result_options" && oldValue !== null) {
          return intl.get("ciq.history.updated.inserted_changed", {
            value: oldValue,
          })
        }

        if (
          epicInnerCIQ !== "anlt_result_options" &&
          oHistory.history_cfield.includes("observation")
        ) {
          return intl.get("ciq.history.updated.changed_observation", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (
          epicInnerCIQ !== "anlt_result_options" &&
          oHistory.history_cfield.includes("measure")
        ) {
          return intl.get("ciq.history.updated.changed_unit", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }

        if (epicInnerCIQ === "anlt_bstatus" && oldValue == "1") {
          return intl.get("ciq.history.updated.changed_deactived_status_analyte")
        }

        if (epicInnerCIQ === "eqpanlt_bstatus" && newValue == "0") {
          return intl.get("ciq.history.updated.deactive_analyte_inner_eqpment")
        }
        if (epicInnerCIQ === "eqpanlt_bstatus" && newValue == "1") {
          return intl.get("ciq.history.updated.active_analyte_inner_eqpment")
        }

        if (searchHistory === "analyte-equipment") {
          if (
            (epicInnerCIQ.includes(":3s") && newValue == "0") ||
            (epicInnerCIQ.includes(":2s") && newValue == "0") ||
            (epicInnerCIQ.includes(":1s") && newValue == "0") ||
            (epicInnerCIQ.includes("6x") && newValue == "0") ||
            (epicInnerCIQ.includes("8x") && newValue == "0") ||
            (epicInnerCIQ.includes("9x") && newValue == "0") ||
            (epicInnerCIQ.includes("10x") && newValue == "0") ||
            (epicInnerCIQ.includes(":4s") && newValue == "0") ||
            (epicInnerCIQ.includes("7T") && newValue == "0") ||
            (newValue === "" && epicInnerCIQ !== "control_bstatus" && epicInnerCIQ !== "eqpanlt_bmax_imprecision")
          ) {
            return intl.get("ciq.history.updated.deactive_role_westigard", {
              rule: oHistory.history_cfield === "eqpanlt_bsigma" ? "Sigma" : oHistory.history_cfield,
            })
          }
        }
        if (searchHistory === "analyte-equipment") {
          if (
            (epicInnerCIQ.includes(":3") && newValue == "1") ||
            (epicInnerCIQ.includes(":2") && newValue == "1") ||
            (epicInnerCIQ.includes(":1") && newValue == "1") ||
            (epicInnerCIQ.includes("6x") && newValue == "1") ||
            (epicInnerCIQ.includes("8x") && newValue == "1") ||
            (epicInnerCIQ.includes("9x") && newValue == "1") ||
            (epicInnerCIQ.includes("10x") && newValue == "1") ||
            (epicInnerCIQ.includes(":4s") && newValue == "1") ||
            (epicInnerCIQ.includes("7T") && newValue == "1") ||
            (newValue === "" && epicInnerCIQ !== "control_bstatus" && epicInnerCIQ !== "eqpanlt_bmax_imprecision")
          ) {
            return intl.get("ciq.history.updated.active_role_westigard", {
              rule: oHistory.history_cfield === "eqpanlt_bsigma" ? "Sigma" : oHistory.history_cfield,
            })
          }
        }
        if (
          (epicInnerCIQ.includes(":3") && newValue == "A") ||
          (epicInnerCIQ.includes(":2") && newValue == "A") ||
          (epicInnerCIQ.includes(":1") && newValue == "A") ||
          (epicInnerCIQ.includes("6x") && newValue == "A") ||
          (epicInnerCIQ.includes("8x") && newValue == "A") ||
          (epicInnerCIQ.includes("9x") && newValue == "A") ||
          (epicInnerCIQ.includes("10x") && newValue == "A") ||
          (epicInnerCIQ.includes(":4s") && newValue == "A") ||
          (epicInnerCIQ.includes("7T") && newValue == "A")
        ) {
          return intl.get("ciq.history.updated.change_westgard_role_inactive_to_active", {
            rule: oHistory.history_cfield,
          })
        }

        if (
          (epicInnerCIQ.includes(":3") && oldValue == "A") ||
          (epicInnerCIQ.includes(":2") && oldValue == "A") ||
          (epicInnerCIQ.includes(":1") && oldValue == "A") ||
          (epicInnerCIQ.includes("6x") && oldValue == "A") ||
          (epicInnerCIQ.includes("9x") && oldValue == "A") ||
          (epicInnerCIQ.includes("8x") && oldValue == "A") ||
          (epicInnerCIQ.includes("10x") && oldValue == "A") ||
          (epicInnerCIQ.includes(":4s") && oldValue == "A") ||
          (epicInnerCIQ.includes("7T") && oldValue == "A")
        ) {
          return intl.get("ciq.history.updated.change_westgard_role_active_to_inactive", {
            rule: oHistory.history_cfield,
          })
        }

        if (epicInnerCIQ === "equipment_bstatus" && oldValue == "1") {
          return intl.get("ciq.history.updated.changed_deactived_status_equipment")
        }

        if (epicInnerCIQ === "anlt_bstatus" && oldValue == "0") {
          return intl.get("ciq.history.updated.changed_actived_status_analyte")
        }

        if (epicInnerCIQ === "equipment_bstatus" && oldValue == "0") {
          return intl.get("ciq.history.updated.changed_actived_status_equipment")
        }

        if (epicInnerCIQ === "anlt_decimal_places") {
          return intl.get("ciq.history.updated.changed_decimal", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ === "anlt_cname") {
          return intl.get("ciq.history.updated.changed_name", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ === "anlt_sector_nid") {
          return intl.get("ciq.history.updated.changed_sector", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }

        if (epicInnerCIQ === "anlt_type") {
          return intl.get("ciq.history.updated.changed_type", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }

        if (oHistory.history_cfield === "eqpanlt_bsigma") {
          if (newValue === "1") {
            return intl.get("ciq.history.updated.active_role_westigard", {
              rule: "Sigma",
            })
          }

          if (!oldValue) {
            return intl.get("ciq.history.updated.deactive_role_westigard", {
              rule: "Sigma",
            })
          }
        }

        // EQUIPMENT

        if (epicInnerCIQ === "equipment_casset_number") {
          return intl.get("ciq.history.updated.changed_eqp_asset_number", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ === "equipment_cserial_number") {
          return intl.get("ciq.history.updated.changed_eqp_serial_number", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ === "equipment_cobservation") {
          return intl.get("ciq.history.updated.changed_eqp_obs", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ === "equipment_cname") {
          return intl.get("ciq.history.updated.changed_eqp_cname", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ === "equipment_cmanufacturer") {
          return intl.get("ciq.history.updated.changed_eqp_cmanufacture", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }

        // update equipment sector
        if (epicInnerCIQ === "equipment_sector_nid") {
          const oOldValues = JSON.parse(oldValue)
          const oNewValues = JSON.parse(newValue)

          if (oOldValues) {
            return intl.get("ciq.history.updated.changed_sector", {
              oldValue: oOldValues?.sector_cname,
              newValue: oNewValues?.sector_cname,
            })
          }

          return intl.get("ciq.history.updated.add_eqp_sector", {
            newValue: oNewValues?.sector_cname,
          })
        }

        if (epicInnerCIQ === "equipment_analyte" && oldValue === null) {
          return intl.get("ciq.history.updated.insert_analyte_in_eqp", {
            analyte: newValue,
          })
        }
        if (epicInnerCIQ === "equipment_analyte" && newValue === null) {
          return intl.get("ciq.history.updated.delete_analyte", {
            analyte: oldValue,
          })
        }
        if (epicInnerCIQ === "eqpanlt_bmax_imprecision" && newValue === "1") {
          return intl.get("ciq.history.updated.changed_active_imprecision_maximum")
        }
        if (epicInnerCIQ === "eqpanlt_bmax_imprecision" && oldValue === "1") {
          return intl.get("ciq.history.updated.changed_deactive_imprecision_maximum")
        }

        if (epicInnerCIQ === "eqpanlt_nimprecision_value" && newValue && oldValue) {
          return intl.get(
            "ciq.history.updated.value_inaccuracy_manual_oldValue_to_newValue",
            {
              oldValue,
              newValue,
            },
          )
        }
        if (epicInnerCIQ === "eqpanlt_nimprecision_value" && newValue) {
          return intl.get("ciq.history.updated.value_inaccuracy_manual", {
            value: newValue,
          })
        }

        if (epicInnerCIQ === "eqpanlt_cjustification" && newValue && oldValue) {
          return intl.get(
            "ciq.history.updated.justification_inaccuracy_manual_oldValue_to_newValue",
            {
              oldValue,
              newValue,
            },
          )
        }
        if (epicInnerCIQ === "eqpanlt_cjustification" && newValue) {
          return intl.get("ciq.history.updated.justification_inaccuracy_manual", {
            value: newValue,
          })
        }

        if (epicInnerCIQ.includes("analyte_run_status_change") && newValue) {
          const oNewValues = JSON.parse(newValue)

          const runsStausHashmap = {
            1: "ciq.history.updated.analyte_run_status_pending",
            2: "ciq.history.updated.analyte_run_status_disapproved",
            3: "ciq.history.updated.analyte_run_status_approved",
          }

          return intl.get(runsStausHashmap[oNewValues?.status_nid || 1], {
            run_number: oNewValues?.run_number,
            anlt_cname: oNewValues?.anlt_cname,
          })
        }

        // EQUIPMENT ANALYTE
        if (epicInnerCIQ === "eqpanlt_cintegration_code") {
          if (oldValue) {
            return intl.get("ciq.history.updated.update_equipement_analyte_code", {
              oldValue,
              newValue
            })
          }
          
          return intl.get("ciq.history.updated.add_equipement_analyte_code", {
            newValue
          })
        }

        // CONTROL

        if (epicInnerCIQ.includes("control_bstatus") && oldValue == "1") {
          return intl.get("ciq.history.updated.deactive_control")
        }
        if (epicInnerCIQ.includes("control_bstatus") && oldValue == "0") {
          return intl.get("ciq.history.updated.active_control")
        }

        if (epicInnerCIQ?.includes("control_dexpiration")) {
          return intl.get("ciq.history.updated.changed_dexpiration", {
            oldValue: transformDate(oldValue),
            newValue: transformDate(newValue),
          })
        }

        if (epicInnerCIQ?.includes("control_cname")) {
          return intl.get("ciq.history.updated.changed_cname", {
            oldValue,
            newValue,
          })
        }

        if (epicInnerCIQ?.includes("control_cmanufacturer")) {
          return intl.get("ciq.history.updated.changed_cmanufacturer", {
            oldValue,
            newValue,
          })
        }

        if (epicInnerCIQ?.includes("control_elevel")) {
          return intl.get("ciq.history.updated.changed_level", {
            oldValue,
            newValue,
          })
        }

        if (epicInnerCIQ?.includes("control_cbatch")) {
          return intl.get("ciq.history.updated.changed_cbatch", {
            oldValue,
            newValue,
          })
        }

        if (epicInnerCIQ?.includes("control_analyte") && newValue === null) {
          return intl.get("ciq.history.updated.changed_deslinked_control_analyte", {
            oldValue,
          })
        }
        if (epicInnerCIQ?.includes("control_analyte")) {
          return intl.get("ciq.history.updated.changed_linked_control_analyte", {
            newValue,
          })
        }

        if (
          epicInnerCIQ?.includes("cntrlanlt_bstatus") &&
          (oldValue === "0" || oldValue === "")
        ) {
          return intl.get("ciq.history.updated.change_status_analyte_linked_deactive")
        }
        if (epicInnerCIQ?.includes("cntrlanlt_bstatus") && oldValue === "1") {
          return intl.get("ciq.history.updated.change_status_analyte_linked_active")
        }

        if (epicInnerCIQ?.includes("_norder")) {
          return `O analito foi alterado da posição ${+oldValue + 1} para posição ${
            +newValue + 1
          }.`
        }

        if (epicInnerCIQ !== "anlt_result_options" && newValue === "C") {
          return intl.get("ciq.history.updated.changed_result_options_conform", {
            oldValue: epicInnerCIQ,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ !== "anlt_result_options" && newValue === "N") {
          return intl.get("ciq.history.updated.changed_result_options_not_conform", {
            oldValue: epicInnerCIQ,
            newValue: newValue,
          })
        }

        if (epicInnerCIQ === "cntrlanlt_naverage" && !oldValue) {
          return intl.get("ciq.history.updated.changed_average", { average: newValue })
        }
        if (epicInnerCIQ === "cntrlanlt_naverage" && newValue && oldValue) {
          return intl.get(
            "ciq.history.updated.changed_average_from_oldvalue_to_newValue",
            { oldValue, newValue },
          )
        }

        if (epicInnerCIQ === "cntrlanlt_nstandard_deviation" && !oldValue) {
          return intl.get("ciq.history.updated.changed_standard_ndeviation", {
            standard_deviation: newValue,
          })
        }

        if (epicInnerCIQ === "cntrlanlt_nstandard_deviation" && newValue && oldValue) {
          return intl.get(
            "ciq.history.updated.changed_standard_ndeviation_from_oldvalue_to_newValue",
            { oldValue, newValue },
          )
        }
        
        if (
          epicInnerCIQ === "anlt_biovar_nid" &&
          oldValue !== null &&
          newValue !== null
        ) {
          return intl.get("ciq.history.updated.changed_biological_variable", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        if (epicInnerCIQ === "anlt_biovar_nid" && newValue === null) {
          return intl.get("ciq.history.updated.remove_biological_variable", {
            oldValue: oldValue,
          })
        }
        if (epicInnerCIQ === "anlt_biovar_nid" && oldValue === null) {
          return intl.get("ciq.history.updated.changed_biological_variable_to", {
            newValue: newValue,
          })
        }

        if (epicInnerCIQ !== "anlt_result_options") {
          return intl.get("ciq.history.updated.changed_result_options", {
            oldValue: oldValue,
            newValue: newValue,
          })
        }
        break

      case "sigma":
        const cnew_value = JSON.parse(newValue)
        const cold_value = JSON.parse(oldValue)
        
        if (epicInnerCIQ === "sigma") {
          const oldSigmaValue = cold_value?.eqpanlt_sigma
          const newSigmaValue = cnew_value?.eqpanlt_sigma
          const analyteName = cnew_value?.anlt_cname
          
          if (!oldSigmaValue) {
            return intl.get("ciq.history.sigma.insert_sigma", {
              analyte: analyteName,
              value: fnFormatedNumber(newSigmaValue),
            })
          }

          return intl.get("ciq.history.sigma.changed_sigma", {
            analyte: analyteName,
            oldValue: fnFormatedNumber(oldSigmaValue),
            newValue: fnFormatedNumber(newSigmaValue),
          })
        }

        if (epicInnerCIQ === "bsigma") {
          const newSigmaValue = cnew_value?.bsigma
          const analyteName = cnew_value?.anlt_cname
          
          if (newSigmaValue) {
            return intl.get("ciq.history.sigma.enable_sigma", {
              analyte: analyteName,
            })
          }

          return intl.get("ciq.history.sigma.disable_sigma", {
            analyte: analyteName,
          })
        }

        if (
          epicInnerCIQ === "biovar_nid" &&
          oldValue !== null &&
          newValue !== null
        ) {
          return intl.get("ciq.history.updated.changed_biological_variable_with_analyte", {
            oldValue: cold_value?.biovar_analyte,
            newValue: cnew_value?.biovar_analyte,
            analyte: cnew_value?.anlt_cname,
          })
        }
        if (epicInnerCIQ === "biovar_nid" && newValue === null) {
          return intl.get("ciq.history.updated.remove_biological_variable_with_analyte", {
            oldValue: cold_value?.biovar_analyte,
            analyte: update_drm?.anlt_cname,
          })
        }
        if (epicInnerCIQ === "biovar_nid" && oldValue === null) {
          return intl.get("ciq.history.updated.changed_biological_variable_to_with_analyte", {
            newValue: cnew_value?.biovar_analyte,
            analyte: cnew_value?.anlt_cname,
          })
        }

        if (epicInnerCIQ.includes("avarage_drm")) {
          return intl.get("sigma.drm_text.update_avarage_drm", {
            oldValue: fnFormatedNumber(cold_value?.avarage),
            analyte: cnew_value?.anlt_cname || cnew_value?.antl_cname,
            newValue: fnFormatedNumber(cnew_value?.avarage),
          })
        } else if (epicInnerCIQ.includes("drm")) {
          if (oldValue === null) {
            return intl.get("sigma.drm_text.insert_drm", {
              value: fnFormatedNumber(cnew_value?.eqpanltdrm_nvalue),
              analyte: cnew_value?.anlt_cname,
            })
          } else if (oldValue !== null && cnew_value?.eqpanltdrm_nvalue === null) {
            return intl.get("sigma.drm_text.delete_drm", {
              value: fnFormatedNumber(cold_value?.eqpanltdrm_nvalue),
              analyte: cnew_value?.anlt_cname,
              reason: cnew_value?.eqpanltdrm_creason,
            })
          } else if (cold_value && cnew_value) {
            return intl.get("sigma.drm_text.update_drm", {
              oldValue: fnFormatedNumber(cold_value?.eqpanltdrm_nvalue),
              newValue: fnFormatedNumber(cnew_value?.eqpanltdrm_nvalue),
              reason: cnew_value?.eqpanltdrm_creason,
              analyte: cnew_value?.anlt_cname,
            })
          } else {
            return ""
          }
        } else {
          return ""
        }

      case "launched":
        const launch = JSON.parse(newValue)
        const control = JSON.parse(newValue).control
        const option = JSON.parse(newValue).option
        const parseObj = JSON.parse(newValue)
        const new_value = parseObj.new
        const old_value = parseObj.old
        const oAnalyte = launch?.analyte
        const oRun = launch?.run
        const cLaunchObservation = launch?.eqpanltlaunch_cobservation

        // launch observation
        if (
          oHistory?.history_cfield === "eqpanltlaunch_cobservation" &&
          cLaunchObservation
        ) {
          if (oldValue) {
            return intl.get("ciq.history.launched.update_launch_observation", {
              analyte: oAnalyte?.anlt_cname,
              level: control?.control_elevel,
              runNumber: oRun?.eqpanltrun_number,
              observation: cLaunchObservation,
              oldObservation: oldValue,
            })
          }

          return intl.get("ciq.history.launched.insert_launch_observation", {
            analyte: oAnalyte?.anlt_cname,
            level: control?.control_elevel,
            runNumber: oRun?.eqpanltrun_number,
            observation: cLaunchObservation,
          })
        }

        if (new_value && old_value) {
          const old_option = parseObj.oldOption

          if (new_value.eqpanltlaunch_change_reason) {
            return intl.get("ciq.history.launched.updated_launched_reason", {
              analyte: epicInnerCIQ,
              oldValue: parseObj?.old.eqpanltlaunch_nvalue,
              newValue: parseObj?.new.eqpanltlaunch_nvalue,
              reason: new_value?.eqpanltlaunch_change_reason,
            })
          } else if (option && old_option) {
            return intl.get("ciq.history.launched.updated_launched", {
              analyte: epicInnerCIQ,
              oldValue: old_option.resultopt_cdescription,
              newValue: option.resultopt_cdescription,
            })
          }
          return intl.get("ciq.history.launched.updated_launched", {
            analyte: epicInnerCIQ,
            oldValue: old_value.eqpanltlaunch_nvalue,
            newValue: new_value.eqpanltlaunch_nvalue,
          })
        } else if (launch?.eqpanltlaunch_nvalue === undefined || launch?.eqpanltlaunch_nvalue === null) {
          return intl.get("ciq.history.launched.insert_launch_option", {
            analyte: epicInnerCIQ,
            level: control?.control_elevel,
            option: option?.resultopt_cdescription,
          })
        } else if (launch.eqpanltlaunch_nvalue !== null) {
          return intl.get("ciq.history.launched.insert_launch_value", {
            analyte: epicInnerCIQ,
            level: control?.control_elevel,
            value: String(launch?.eqpanltlaunch_nvalue).replace(".", ","),
          })
        }
        break
      case "deleted":
        const values = JSON.parse(oldValue)
        if (epicInnerCIQ === "run") {
          return intl.get("ciq.history.deleted.deleted_run_description", {
            run: values?.eqpanltrun_number,
            analyte: values?.analyte?.anlt_cname,
          })
        }
    }
  }

  const debouncedHandleChange = debounce((value) => {
    const days = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    setDataHistory([])
    setPerPage(1)
    const valueLowerCase = value.toLowerCase().trim()

    if (
      valueLowerCase.includes("created") ||
      valueLowerCase.includes("create") ||
      valueLowerCase.includes("criou") ||
      valueLowerCase.includes("cria") ||
      valueLowerCase.includes("criar") ||
      valueLowerCase.includes("criação") ||
      valueLowerCase.includes("criado") ||
      valueLowerCase.includes("criação do analito")
    ) {
      setDataHistory([])

      setSearchType("&search_type=created&")
      setSearchText("")

      return
    } else if (
      valueLowerCase.includes("alterou") ||
      valueLowerCase.includes("alteração") ||
      valueLowerCase.includes("alterado") ||
      valueLowerCase.includes("altera") ||
      valueLowerCase.includes("atualizou") ||
      valueLowerCase.includes("atualização") ||
      valueLowerCase.includes("atualizado") ||
      valueLowerCase.includes("atualiza") ||
      valueLowerCase.includes("atualizar") ||
      valueLowerCase.includes("alt") ||
      valueLowerCase.includes("update") ||
      valueLowerCase.includes("updated") ||
      valueLowerCase.includes("upd")
    ) {
      setDataHistory([])

      setSearchType("&search_type=update&")
      setSearchText("")

      return
    } else if (valueLowerCase === "") {
      setDataHistory([])

      setSearchType("")
      setSearchText("")
    }

    const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/
    const match = valueLowerCase.match(dateRegex)
    if (match) {
      const [_, day, month, year] = match
      if (day && month && year) {
        setSearchText(`&search_text=${year}-${month}-${day}&`)
        setSearchType("")
        return
      }
    }

    setSearchText(`search_text=${valueLowerCase}&`)
    setSearchType("")
  }, 500)

  useEffect(() => {
    setDataHistory((oldState) => [...oldState, ...history])
  }, [history])

  const historyUserName = (oHistory) => {
    if (oHistory?.history_user_cname) return oHistory.history_user_cname

    if (oHistory?.history_customer_application?.custapp_cname)
      return `${oHistory.history_customer_application.custapp_cname} ${intl.get(
        "ciq.history_ciq.customer_application_flag",
      )}`

    return ""
  }

  const bHasCustomerApplication = dataHistory.some((h) => h?.history_customer_application)

  return (
    <>
      <InfiniteScroll
        fnNext={(page) => fnNextPage(page)}
        nTotalPages={infoInfinitScroll.last_page}
        nDataLength={dataHistory.length || 0}
        bStopPagination={infoInfinitScroll.next_page_url === null ? true : false}
        scrollableTarget="modal-overflow-content"
      >
        <div className={styles.wrapperHistoric}>
          <Input
            width="100%"
            className={styles.inputSearch}
            isSearch
            placeholder={intl.get("ActivityHistory.search_history")}
            onChange={(ev) => {
              debouncedHandleChange(ev.target.value)
            }}
          />

          <table className={styles.table}>
            <thead className={styles.head}>
              <tr>
                <th>{intl.get("ciq.history_ciq.data")}</th>
                <th>
                  {bHasCustomerApplication
                    ? intl.get("ciq.history_ciq.made_by")
                    : intl.get("ciq.history_ciq.username")}
                </th>
                <th>{intl.get("ciq.history_ciq.type")}</th>
                <th>{intl.get("ciq.history_ciq.action")}</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {dataHistory.map((item) => (
                <tr key={item.history_caction}>
                  <td>
                    {item.history_data} - {item.history_hour}
                  </td>
                  <td>{historyUserName(item)}</td>
                  <td>{fnManiputeHistoryType(item.history_caction, item)}</td>
                  <td style={{ maxWidth: 328, width: 328 }}>
                    <TextTruncate cText={fnManiputeHistoryAction(item.history_caction, item)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </InfiniteScroll>
      {isLoadHistory && (
        <div className={styles.flexCenter} style={{ height: "6rem" }}>
          <RcmpLoading bShow={true} size={50} />
        </div>
      )}
    </>
  )
}
